import React from "react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Contributor } from "../../types/form";

interface ContributorListProps {
  contributors: Contributor[];
  onEdit: (contributor: Contributor) => void;
  onDelete: (contributor: Contributor) => void;
}

const ContributorList: React.FC<ContributorListProps> = ({
  contributors,
  onEdit,
  onDelete,
}) => {
  if (!contributors || contributors.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <div className="space-y-2">
        {contributors.map((contributor) => (
          <div
            key={contributor.id}
            className="flex items-center justify-between p-3 transition-colors bg-white border border-neutral-200 rounded-md hover:border-primary-300 hover:bg-primary-50"
          >
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-neutral-900 truncate">
                {contributor.name}
              </p>
              <p className="text-xs text-neutral-600 truncate">
                {contributor.roles}
              </p>
            </div>
            <div className="flex gap-1 ml-3">
              <button
                type="button"
                onClick={() => onEdit(contributor)}
                className="border border-transparent flex items-center justify-center p-2 text-primary-700 transition-colors rounded-md hover:bg-primary-100 focus:outline-none focus-visible:border-primary-700"
                title="Edit contributor"
                aria-label={`Edit ${contributor.name}`}
              >
                <PencilIcon className="w-4 h-4" />
              </button>
              <button
                type="button"
                onClick={() => onDelete(contributor)}
                className="border border-transparent flex items-center justify-center p-2 text-danger-600 transition-colors rounded-md hover:bg-danger-100 focus:outline-none focus-visible:border-danger-500"
                title="Delete contributor"
                aria-label={`Delete ${contributor.name}`}
              >
                <TrashIcon className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContributorList;
